import React from 'react'
import { useTranslation } from '@mc/i18n'
import type { PlansTier } from '@mc/plans-ui'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../../../i18n'

interface PricingCellProps {
  tier: PlansTier
  mode?: 'monthly' | 'yearly'
}

export const PricingCell = ({
  tier: {
    displayMonthlyPrice,
    displayMonthlyPriceWithDiscount,
    displayYearlyPrice,
    displayYearlyPriceWithDiscount,
  },
  mode = 'monthly',
}: PricingCellProps) => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const price = mode === 'monthly' ? displayMonthlyPrice : displayYearlyPrice
  const priceWithDiscount =
    mode === 'monthly'
      ? displayMonthlyPriceWithDiscount
      : displayYearlyPriceWithDiscount
  const hasDiscountPrice = !!priceWithDiscount

  if (hasDiscountPrice) {
    return (
      <span className='d-flex flex-wrap justify-content-center'>
        <span
          aria-label={t('plans.features.pricing.cell.previous', {
            previousPrice: price,
          })}
          className='mc-mx-1 mc-text-color--gray-500 mc-text--strike'
        >
          {price}
        </span>
        <span
          aria-label={t('plans.features.pricing.cell.current', {
            price: priceWithDiscount,
          })}
          className='mc-text-color--light mc-text--bold'
        >
          {priceWithDiscount}
        </span>
      </span>
    )
  }

  return (
    <span aria-label={t('plans.features.pricing.cell.price', { price })}>
      {price}
    </span>
  )
}
